// Vendor Libs
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {get} from 'lodash';

// Redux Actions
import {
    registerForm,
    setFieldValue,
    setFieldValues,
    setFormCustomPath,
    setFormSubmitted,
    resetForm,
} from '../actions/form-data-actions';

// Configs
import servicesFormConfig from '../../config/services-form-config';

const useFormData = (formName) => {
    const locallyLocked = useSelector(({recordLocking: {locallyLocked = {}} = {}}) => locallyLocked);
    const lockedRecords = useSelector(({recordLocking: {lockedRecords = {}} = {}}) => lockedRecords);
    const formData = useSelector((state) => state.formData);
    const routerParams = useSelector(({router: {routerParams = {}} = {}}) => routerParams);
    const servicesSearchData = useSelector((state) => state.servicesSearchData);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(registerForm(formName));
    }, []);

    const getChildrenProps = () => {
        const providerServiceDataKey = get(servicesFormConfig, [formName, 'providerServiceDataKey']);

        return {
            formData: get(formData, [formName], {}),
            formName,
            locallyLocked,
            lockedRecords,
            registerForm: (formName) => dispatch(registerForm(formName)),
            resetForm: (...args) => dispatch(resetForm(formName, ...args)),
            routerParams,
            searchFetching: get(servicesSearchData, [providerServiceDataKey, 'fetching']),
            searchValues: get(servicesSearchData, [providerServiceDataKey, 'searchData', 'content', '0'], {}),
            setFieldValue: (...args) => dispatch(setFieldValue(formName, ...args)),
            setFieldValues: (...args) => dispatch(setFieldValues(formName, ...args)),
            setFormCustomPath: (customPath) => dispatch(setFormCustomPath(formName, customPath)),
            setFormSubmitted: (actionShouldFetch, submitted) =>
                dispatch(setFormSubmitted(actionShouldFetch, formName, formName, submitted)),
        };
    };

    return getChildrenProps();
};

export default useFormData;
